import { lazy, Suspense, useMemo } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { WebmotorsLoader } from '@/components/webmotors-loader';

const MyAccount = lazy(() =>
	import('@/page/v1/my-account').then(m => ({ default: m.MyAccountPage }))
);

const LivenessVerification = lazy(() =>
	import('@/page/v1/liveness-verification').then(m => ({ default: m.LivenessVerificationPage }))
);

const Router = () => {
	const router = useMemo(
		() =>
			createBrowserRouter(
				[
					{
						path: '/',
						element: (
							<Suspense fallback={<WebmotorsLoader />}>
								<MyAccount />
							</Suspense>
						)
					},
					{
						path: '/verificacao',
						element: (
							<Suspense fallback={<WebmotorsLoader />}>
								<LivenessVerification />
							</Suspense>
						)
					}
				],
				{ basename: import.meta.env.BASE_URL.replace(/\/$/, '') }
			),
		[]
	);

	return <RouterProvider router={router} future={{ v7_startTransition: true }} />;
};

Router.displayName = 'Router';

export { Router };
